import * as React from 'react';
import {
  ActionButton,
  addRowToPayload,
  fetchApi,
  getInitialValuesExistingRow,
  makeCompoundPayload,
  notifyError,
  notifyResponse,
  useCacheRecord,
} from 'gossamer-front-end';
import { InstitutionMember, InstitutionMemberRow, UserView } from 'cb-model';
import { Task } from 'gossamer-model';

export interface MemberInviteDeleteButtonProps {
  value: string;
}

export const VerifiedMemberMakeAdminButton = (props: MemberInviteDeleteButtonProps): React.JSX.Element => {
  const { data, error } = useCacheRecord<InstitutionMemberRow>(InstitutionMember, props.value);
  if (!!error) {
    notifyError(error, 'An error occurred while fetching the member data');
    return null;
  }
  return (
    <ActionButton
      label="Make Admin"
      size="sm"
      variant="warning"
      waiting={!data}
      execute={async (resetCache) => {
        try {
          const payload = makeCompoundPayload('save');
          const row = getInitialValuesExistingRow(InstitutionMember, data);
          row.is_admin = true;
          addRowToPayload(payload, InstitutionMember, row);
          const response = await fetchApi('POST', `/main/institution-member-update-multi`, payload);
          resetCache(InstitutionMember.id, props.value);
          resetCache(Task.id);
          resetCache(UserView.id, data.user_id);
          notifyResponse(response);
        } catch (e) {
          notifyError(e, 'An error occurred while making the member an admin');
        }
      }}
    />
  );
};
